import axios from "axios";
import { isTokenExpired } from '../utils/jwtTokenUtils';
import { handleMSALalAccessToken } from '../utils/handleAccessToken';


export const addAuthInterceptor = async (client) => {
  // === Axios Request Interceptor ===
  client.interceptors.request.use(
    async (config) => {
      let accessToken = null;
      // Try to get Okta token from sessionStorage
      const oktaTokenObj = JSON.parse(
        sessionStorage.getItem("okta-token-storage") || "{}",
      );
      const oktaAccessToken = oktaTokenObj?.idToken?.idToken;
      if (oktaAccessToken) {
        accessToken = oktaAccessToken;
      } else {
        // === MSAL FLOW ===
        accessToken = JSON.parse(localStorage.getItem('msal-token-storage'));
        const path = window.location.pathname.match(/\/survey\/(\d+)\/(\d+)\/(\d+)/);
        // Only set msal-token-storage if not already present
        if (!accessToken) {
          accessToken = await handleMSALalAccessToken();
          localStorage.setItem('msal-token-storage', JSON.stringify(accessToken));
        } else if (path) {
          let surveyId = path[1];
          let code = path[2];
          let languageId = path[3];
          localStorage.setItem("userSurveyInfo", JSON.stringify({ surveyId, code, languageId }));
        }
      }
      if (accessToken && !isTokenExpired(accessToken)) {
        localStorage.setItem("isUserLoggedIn", "true");
        config.headers.Authorization = `Bearer ${accessToken}`;
      }else{
        logoutAndRedirect();
        return Promise.reject(new Error('No valid token'));
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
};

export const createApiClient = (baseURL, contentType = "application/json") => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": contentType,
    },
    //withCredentials: true,
  });
  return client;
};

const logoutAndRedirect = () => {
  localStorage.clear();
  // Try to get survey info from sessionStorage
  let surveyId, code, languageId;
  const userSurveyInfo = localStorage.getItem("userSurveyInfo");
  if (userSurveyInfo) {
    try {
      const info = JSON.parse(userSurveyInfo);
      surveyId = info.surveyId;
      code = info.code;
      languageId = info.languageId;
    } catch {}
  }
  // If not in localStorage, try to read from current URL
  if (!surveyId || !code || !languageId) {
    const match = window.location.pathname.match(/\/survey\/(\d+)\/(\d+)\/(\d+)/);
    if (match) {
      surveyId = match[1];
      code = match[2];
      languageId = match[3];
    }
  }
  let loginUrl = "/login";
  if (surveyId && code && languageId) {
    // Encode surveyId and code for security
    const encodedSurveyId = encodeURIComponent(btoa(surveyId));
    const encodedCode = encodeURIComponent(btoa(code));
    const encodedLanguageId = encodeURIComponent(btoa(languageId));
    loginUrl = `/login?surveyId=${encodedSurveyId}&code=${encodedCode}&languageId=${encodedLanguageId}&isExternalUserSurvey=true`;
    localStorage.setItem("userSurveyInfo", JSON.stringify({ surveyId, code, languageId }));
  }
  sessionStorage.clear();
  window.location.href = loginUrl;
};

